import { useMemo } from 'react';
import { Participant } from 'livekit-client';

export const useParticipantElementRefs = (
    setElementRef: (id: string) => (element: HTMLDivElement | null) => void,
    participants: Participant[],
): Map<string, (element: HTMLDivElement | null) => void> => {
    return useMemo(() => {
        const refs = new Map<string, (element: HTMLDivElement | null) => void>();
        participants.forEach((participant) => {
            refs.set(participant.identity, setElementRef(participant.identity));
        });
        return refs;
    }, [participants, setElementRef]);
};
